export default __webpack_public_path__ + "static/media/international-women-s-day-appbar-tile.35ca251e.svg";